/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

/**
 * Styles service
 * @namespace Styles
 * @description Service for injection of css rules
 */
!function () {
    "use strict";

    angular.module('webReader').service('Styles', constructor);
    /**
     * @name Styles
     * @function
     * @description Creates or returns reference to singleton object that allows to work with this service
     * @returns {Object} - singleton service object
     * @memberof Styles
     */
    function constructor(NetworkService) {
        var self = this;
        var stylesBaseName = 'chapter-style-';
        var styleUniqPart = 0;
        var baseUrlCollection = {};

        /**
         * @name "getNewStyleSheetName"
         * @function
         * @description Generates new unique classname
         * @returns {String} - generated unique css classname
         * @memberof Styles
         */
        self.getNewStyleSheetName = function(){
            var newName = stylesBaseName + styleUniqPart;

            styleUniqPart += 1;
            return newName;
        };

        /**
         * @name "appendStyleSheet"
         * @function
         * @description Loads css rules from CSS accesible by CSSUrl,
         * makes them dependent from specific classname and injects into document.stylesheets
         * @param CSSUrl {String} URL of css file with required rules
         * @param newStyleSheetName {String} Class name that should be root for injected rules
         * @param chapterId {Number} Index of chapter - owner of css style rules set. Required to
         * detect relational URL for css in xhtml doc of chapter
         * @returns {undefined}
         * @memberof Styles
         */
        self.appendStyleSheet = function(CSSUrl, newStyleSheetName, chapterId){
            NetworkService.getStylesheet(CSSUrl).then(
                function(data){
                    var linkElement, sheet, rulesCollection = [];
                    var containerRef = 'div.' + newStyleSheetName + ' ';

                    sheet = document.styleSheets[document.styleSheets.length - 1];

                    rulesCollection = data.trim().split('}');

                     _.each(_.filter(rulesCollection, function(el){
                         return !!el.length;
                     }), function(el, i, collection){
                         el = el.replace('url(', 'url(' + baseUrlCollection[chapterId]);
                         el = el.replace('../', '');

                         if (el.indexOf('@') < 0 ) {
                             document.styleSheets[document.styleSheets.length - 1].insertRule(containerRef + el.replace(',', ','+containerRef) + '}', 0);
                         }
                     });
                }
            );
        };

        /**
         * @name "setStyleBaseUrl"
         * @function
         * @description Defines base URL for styles, i.e. base URL for all xhtml docs - required to compose correct full URL of css
         * @returns {undefined}
         * @memberof Styles
         */
        self.setStyleBaseUrl = function(chapterId, Url){
            baseUrlCollection[chapterId] = Url;
        };
    }
    constructor.$inject = ["NetworkService"];
}();